export const QuizAppRouteNames = {
    default: 'quiz-builder-v2',
    main: 'quiz-builder-main',
    submissions: 'quiz-builder-submissions',
  }